import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CocoCelebrationService } from '@coin/chat-bot-util-types';

@Component({
  selector: 'coin-chat-mascot',
  standalone: true,
  imports: [],
  template: `
    @if (mascotPath()) {
      <img
        alt="Chat Mascot"
        class="mascot-image"
        [src]="mascotPath()" />
    }
  `,
  styleUrl: './chat-mascot.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export default class ChatMascotComponent {
  private celebrationManager = inject(CocoCelebrationService);

  protected readonly mascotPath = signal<string | null>(this.celebrationManager.getMascot());
}
